import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Bucket from "@/services/bucket/bucket";

export function useBulkDeleteBuckets() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids: string[]) => {
      const result = await Bucket.bulkDeleteBuckets(ids);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete buckets");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}
